import React from "react";
import { Box, Checkbox, FormControl, FormControlLabel, Grid, InputLabel, MenuItem, Select, Typography, } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { Translate as T } from "react-localize-redux";
export var DeferredOptions = function (props) {
    var useStyles = makeStyles(function () { return ({
        checked: {},
        label: {
            color: "#293036",
            fontSize: "14px",
            fontStyle: "normal",
            fontWeight: "normal",
        },
        root: {
            "& a": {
                color: props.color,
            },
            "&$checked": {
                color: props.color,
            },
        },
    }); });
    var classes = useStyles();
    return props.deferredOptions && props.deferredOptions.hasDeferred ? (React.createElement(T, null, function (_a) {
        var translate = _a.translate;
        var _b, _c, _d;
        return (React.createElement(React.Fragment, null,
            React.createElement(Grid, { item: true, xs: 12 },
                React.createElement(FormControl, null,
                    React.createElement(FormControlLabel, { labelPlacement: "end", label: React.createElement(Typography, { className: classes.label }, translate("deferredOptions.title")), control: React.createElement(Checkbox, { color: "primary", name: "isDeferred", value: props.deferredOptions.isActive, classes: {
                                checked: classes.checked,
                                root: classes.root,
                            }, onChange: function () { return props.handleSetFields("activeQuote"); } }) }))),
            React.createElement(Box, null,
                React.createElement(Grid, { container: true, direction: "row" }, props.deferredOptions.isActive ? (React.createElement(React.Fragment, null,
                    props.deferredOptions.typesDeferred &&
                        props.deferredOptions.isDynamic &&
                        props.deferredOptions.typesDeferred.length > 0 &&
                        !(props.deferredOptions.typesDeferred[0].value === "all") ? (React.createElement(React.Fragment, null,
                        React.createElement(Grid, { item: true, xs: props.isMobile ? 12 : 6, style: {
                                paddingBottom: props.isMobile ? 5 : 0,
                                paddingRight: props.isMobile ? 0 : 3,
                            } },
                            React.createElement(FormControl, { variant: "outlined", fullWidth: true },
                                React.createElement(InputLabel, null, translate("deferredOptions.typeDeferred")),
                                React.createElement(Select, { onChange: function (evt) {
                                        return props.handleSetFields("typeDeferred", evt.target.value);
                                    }, required: (_b = props.deferredOptions) === null || _b === void 0 ? void 0 : _b.isActive, label: translate("deferredOptions.typeDeferred"), value: props.currentValues.typeDeferred }, props.deferredOptions.typesDeferred.map(function (option, index) { return (React.createElement(MenuItem, { key: index + "_typedeferred", value: option.value }, option.label)); })))))) : null,
                    props.deferredOptions.months &&
                        props.deferredOptions.months.length > 0 ? (React.createElement(Grid, { item: true, xs: 6, sm: 3, style: {
                            paddingLeft: !props.isMobile ? 3 : 0,
                            paddingRight: 3,
                        } },
                        React.createElement(FormControl, { variant: "outlined", fullWidth: true },
                            React.createElement(InputLabel, null, translate("deferredOptions.months")),
                            React.createElement(Select, { required: (_c = props.deferredOptions) === null || _c === void 0 ? void 0 : _c.isActive, value: props.currentValues.months, onChange: function (evt) {
                                    return props.handleSetFields("months", evt.target.value);
                                }, label: translate("deferredOptions.months") }, props.deferredOptions !== undefined &&
                                props.deferredOptions.months !== undefined &&
                                props.deferredOptions.months.map(function (option, index) { return (React.createElement(MenuItem, { key: index + "_month", value: option.value }, option.label)); }))))) : null,
                    props.deferredOptions.monthsOfGrace &&
                        props.deferredOptions.monthsOfGrace.length > 0 ? (React.createElement(Grid, { item: true, xs: 6, sm: 3, style: { paddingLeft: 3 } },
                        React.createElement(FormControl, { variant: "outlined", fullWidth: true },
                            React.createElement(InputLabel, null, translate("deferredOptions.monthsOfGrace")),
                            React.createElement(Select, { required: (_d = props.deferredOptions) === null || _d === void 0 ? void 0 : _d.isActive, value: props.currentValues.monthsOfGrace, onChange: function (evt) {
                                    return props.handleSetFields("monthsOfGrace", evt.target.value);
                                }, label: translate("deferredOptions.monthsOfGrace") },
                                props.deferredOptions !== undefined &&
                                    props.deferredOptions.monthsOfGrace !==
                                        undefined && (React.createElement(MenuItem, { value: "0" }, "0")),
                                props.deferredOptions !== undefined &&
                                    props.deferredOptions.monthsOfGrace !== undefined &&
                                    props.deferredOptions.monthsOfGrace.map(function (option, index) { return (React.createElement(MenuItem, { key: index + "_monthsofgraceOptions", value: option.value }, option.label)); }))))) : null)) : null))));
    })) : null;
};
